import React, { useEffect, useMemo, useState } from 'react';
import { influencers, InfluencerTypes } from 'api';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { ErrorBoundary, Loader } from 'components';
import Form from './Form';
import { initialModel, dataToInitialModel } from './fields';

type Params = 'id';

interface Props {
  itemId?: string;
}

const Index = (props: Props): JSX.Element | null => {
  const { itemId } = props;
  const { id: paramsId = '' } = useParams<Params>();

  const id = useMemo(() => paramsId || itemId || '', [itemId, paramsId]);

  const { data, error } = useQuery(
    [influencers.endpoints.getById(id)],
    () => influencers.getById(id),
    {
      enabled: !!id,
      cacheTime: 0,
    },
  );

  const [initialData, setInitialData] = useState<
    InfluencerTypes.ItemCreateParams | undefined
  >(undefined);

  useEffect(() => {
    if (!id) {
      setInitialData(initialModel);
    } else if (data) {
      const initialFormData = dataToInitialModel(data);

      setInitialData(initialFormData as InfluencerTypes.ItemCreateParams);
    }
  }, [data, id]);

  if (error) {
    return <ErrorBoundary variant="error" />;
  }

  return !initialData ? (
    <Loader height="80vh" variant="centered" />
  ) : (
    <Form
      drawer={!!itemId}
      drawerTitle={`Edit ${data?.profile_name || 'influencer'}`}
      id={id}
      initialData={initialData}
    />
  );
};

export default Index;
